import { render, staticRenderFns } from "./ControlMultiCheck.vue?vue&type=template&id=323b1f4c"
import script from "./ControlMultiCheck.vue?vue&type=script&lang=js"
export * from "./ControlMultiCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports